<div class="loading-content" role="status" aria-live="polite">
  <img [src]="getLoaderSvgPath()"
       [attr.width]="getLoaderSize()"
       [attr.height]="getLoaderSize()"
       alt="Loading..." />
  <div class="loading-content__title" *ngIf="message">
    <span>{{ message | translate }}</span>
  </div>
</div>
